import React, { memo } from 'react';
import { Button, Dialog as SatoDialog, LargeModal } from '@sato/components';

import { Link } from '@components/common/Link';

import { IDialog, ParsedEntry } from '../types';

interface Props {
  data: ParsedEntry<IDialog>;
}

export const Dialog = memo(({ data }: Props) => {
  const {
    variant,
    headline,
    openButtonText,
    ctaButtonText,
    ctaLink,
    closeButtonText,
    media,
    icon,
    triggerVariant,
    ...rest
  } = data;

  if (variant === 'default') {
    return (
      <SatoDialog
        {...rest}
        triggerProps={{ children: openButtonText, variant: triggerVariant }}
        linkComponent={Link}
        buttonComponent={ctaLink ? Link : Button}
        heading={headline}
        actionButton={{
          children: ctaButtonText,
          to: ctaLink,
        }}
        backButton={closeButtonText ? { children: closeButtonText } : undefined}
        icon={icon?.icon}
      />
    );
  }

  const { image, alt, caption } = media ?? {};
  const { src } = image ?? {};

  return (
    <LargeModal
      {...rest}
      triggerProps={{ children: openButtonText }}
      title={headline}
      linkComponent={Link}
      actionButton={{
        children: ctaButtonText,
        to: ctaLink,
      }}
      {...(image
        ? { imageProps: { src, alt, source: 'contentful' }, label: caption }
        : icon?.icon && { icon: icon?.icon })}
    />
  );
});
